import React from "react";
import "./Projects.css";
import CardContains from "../CardContains";
export default function Projects() {
  return (
    <div className="project-card">
      <CardContains
        InstitutionName={"AccSafe (Team Project)"}
        DegreeDetails={
          " • Detects Accidents efficiently by using Android sensors in our smartphones. • Send the Accident location to all the listed numbers for Quick help. • Alert the driver if in any accident-prone area or if any accident occurred nearby. • Also provide alternate routes if any accident has occurred within 500m"
        }
        Year={"  Java | Kotlin | XML | Firebase | GCP| Android Studio"}
      />
      <CardContains
        InstitutionName={"Code Rooms"}
        DegreeDetails={
          "• This website allows multiple user to connect together in the same room and contribute in the same code. • This allows the use to edit the code in real time for everyone."
        }
        Year={
          "  Node.js| Express.js | Socket.io | Html | CSS | Ejs| JavaScript  "
        }
      />
      <CardContains
        InstitutionName={"Ecom-MarketPlace(Team Project )"}
        DegreeDetails={
          "• I have worked in the backend building all the APIs.• This Webapp use microservice based architecture.• Allows user to find required shops and buy product directly from them "
        }
        Year={
          " Node.js| Express.js| Elastic Search | Mongo DB | MySQL | React.js | JavaScript"
        }
      />
    </div>
  );
}
